import packageInfo from '../../package.json';

export default packageInfo.version;


//////////////////
// WEBPACK FOOTER
// ./~/ant-design-vue/es/version/index.js
// module id = 922
// module chunks = 0